import { useQuery } from '@tanstack/react-query';
import { dailyProgressApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Physical progress entries recorded against a job's WBS accounts. */
export function useDailyProgressHistory(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.dailyProgress.history(jobId ?? -1),
    queryFn: ({ signal }) =>
      dailyProgressApiClient.getProgressItems(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 30_000,
    meta: { errorContext: 'progress history' },
  });
}
